import React from 'react'
import {Box} from '@chakra-ui/react'
import {liveTextStyles} from '_themeUtils'

interface LiveTextProps {
    /** The live text content equivalent of burned-in text in an image (WCAG 1.4.5) */
    children: string
}

/**
 * LiveText renders a visually-hidden span that provides a selectable, zoomable,
 * screen-reader-accessible text equivalent for images containing burned-in text
 * (WCAG 1.4.5 – Images of Text).
 *
 * Uses the design system's `liveTextStyles` from `_themeUtils`, following the same
 * pattern as `srOnlyStyles` (e.g. `<Box as="span" sx={srOnlyStyles}>`).
 *
 * When `html.un-assistive` is active, the text becomes visible below the image
 * via the global `.un-assistive .cc-livetext` selector in globalStyles.
 *
 * Place this component immediately after the `<img>`, `<picture>`, or video container.
 */
const LiveText: React.FC<LiveTextProps> = ({children}) => {
    return (
        <Box as="span" className="cc-livetext" sx={liveTextStyles}>
            {children}
        </Box>
    )
}

export {LiveText}
